import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';
import {RoleService} from '../../../services/role.service';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-role-add',
  templateUrl: './role-add.component.html',
  styleUrls: ['./role-add.component.scss']
})
export class RoleAddComponent implements OnInit{

  roleForm: FormGroup;

  modules: any[] = [];
  menus: any[] = [];
  permissions: any[] = [];

  moduleSelected: number | undefined;
  saving = false;

  public data: any;

  isSubmitted = false;

  val: any | null;
  pop: any;

  update = this.translate.instant('Update');
  create = this.translate.instant('Save');
  constructor(private fb: FormBuilder,
              private roleService: RoleService,
              private translate: TranslateService,
              private toast: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router
  ) {
    this.roleForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      isEnable: '',
    });
  }

  ngOnInit(): void {
    this.roleForm.get('isEnable')?.setValue('1');
    this.roleForm.patchValue(this.data)
    console.log(this.roleForm)
  }

  get fc(): any {
    return this.roleForm.controls;
  }

  onFormSubmit(): any {
    this.isSubmitted = true;
    if (this.roleForm.valid){
      this.saving = true;

      if (this.data){
        this.roleForm.get('isEnable')?.setValue(this.roleForm.get('isEnable')?.value === '1');
        this.roleService.updateProfile(this.data.id, this.roleForm.value).subscribe({
          next: (val: any) => {
            this.toast.success(this.translate.instant('permission') + ' ' + this.translate.instant('editeed') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            //const errors: any[] = err.error.violations;

            if (err.error && err.error.violations){
              err.error.violations.forEach((v) =>
              {
                if (v.propertyPath === 'name'){
                  this.roleForm.get('name')?.setErrors({serverError: v.message});
                }
                this.saving = false;

              });
            }
            else {
              this.toast.error(err['hydra:title'], 'Error');
              this.saving = false;
            }

          }
        });
      }else {
        this.roleForm.get('isEnable')?.setValue(this.roleForm.get('isEnable')?.value === '1');
        this.roleService.addProfile(this.roleForm.value).subscribe({
          next: (val: any) => {
            this.toast.success(this.translate.instant('profile') + ' ' + this.translate.instant('created') + ' ' + this.translate.instant('successfully!'), 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
          },
          error: (err: any) =>
          {
            this.saving = false;
            console.log(err);
            const errors: any[] = err.violations;
            console.log(errors);

            if (errors){
              errors.forEach((v) => {
                if (v.propertyPath === 'name') {
                  this.roleForm.get('name')?.setErrors({serverError: v.message});
                }
                // window.scrollTo({ top: 0, behavior: 'smooth'});
                this.saving = false;
              });
            }
            else {
              // window.scrollTo({ top: 0, behavior: 'smooth'});
              this.toast.error(err['hydra:title'], 'Error');
              this.saving = false;
            }

          }
        });
      }



    }
  }

}
